import { LegalPageLayout } from '@/components/layout/LegalPageLayout';
import { CookiesPolicyContent } from '@/components/legal/CookiesPolicyContent';

export const CookiesPolicyPage = () => {
  return (
    <LegalPageLayout
      title="Cookies Policy"
      lastUpdated="December 27, 2025"
    >
      <CookiesPolicyContent />
    </LegalPageLayout>
  );
};
